// Vuex Store
import store from '../store/store'

export default (projectAddDataId) => {
  let value = null

  const projectAddDataList = store.state.ListasModule.project_add_data
  //console.log('projectAddDataId', projectAddDataId)
  //console.log('projectAddDataList', projectAddDataList)

  if (projectAddDataList) {

    if (!projectAddDataList || !projectAddDataId) {
      return value
    }

    if (Array.isArray(projectAddDataList)) {

      projectAddDataList.forEach(projectAddData => {
        if (projectAddData.configId === projectAddDataId) {
          value = projectAddData.value
        }
      })
    }
  }

  //console.log('projectAddData value', value)

  return value
}
